import { forwardRef } from "react";

import { Switch } from "@shared/components/DataEntry";
import { FormField } from "../FormField";
import { FormSwitchProps } from "../../types";

export const FormSwitch = forwardRef<HTMLInputElement, FormSwitchProps>(({ name, ...props }, ref) => (
  <FormField name={name}>
    <Switch ref={ref} name={name} {...props} />
  </FormField>
));

FormSwitch.displayName = "Form.Switch";
